import { checkItemLocaleCode } from "../components/helper";
import { updateValueService } from "../shared/updateValueService";
import { LOCALE_RU } from "../constant";
import {
    CATEGORY_URL_PART,
    FORM_URL_PART,
    PRODUCT_URL,
    PROPERTIES_URL,
    PROPERTY_URL_PART,
    deleteFetchRequest,
    getFetchRequest,
    postFetchRequest,
    patchFetchRequest
} from "../store/requests";
import { formsProductService } from "./formsProductService";
import { formsStorage } from "./formsStorage";
import {errorCallback, makeUrl, successCallbackEmpty} from "../util";
import {propertyNamesService} from "./propertyNamesService";
import {propertiesService} from "./propertiesService";
import {lastUpdateTimeService} from "./lastUpdateTimeService";
import i18n from "../i18nService";

const createObjectFromPropertiesList = (properties, i18nInstance = i18n) => {
    if(properties && properties.length) {
        const preparedPropertiesObject = {};
        properties.forEach(it => preparedPropertiesObject[it.id] = {
            ...it,
            localizedName: propertyNamesService.getLocalization(i18nInstance.resolvedLanguage, it, true, i18nInstance),
        });
        return preparedPropertiesObject;
    } else {
        return {};
    }
};

const prepareProductPropertyForms = (formsList) => {
    return formsList.map(it => {
        return {id: it.id, included: it.included !== false };
    });
};

export const getPropertyDataById = (propertyId) => {
    return productSaveService.getProduct().properties[propertyId];
};

const prepareProductProperty = (property) => {
    return {
        value: Array.isArray(property.value) ? JSON.stringify(property.value) : property.value,
        productForms: prepareProductPropertyForms(property.productForms || []),
        minValue: property.minValue,
        maxValue: property.maxValue,
        referenceBookId: property.referenceBookId || '',
    };
};

export const productSaveService = {
    currentProduct: {},
    lastProductUpdateTime: null,
    productUpdateObservers: [],
    lastUsedForm: {},
    lastUsedReferenceBookId: '',
    lastUsedReferenceBookCode: '',
    lastCreatedPropertyId: null,

    loadProduct(productId, callback, i18nInstance = i18n) {
        try {
            getFetchRequest(makeUrl([PRODUCT_URL, productId, '/?withForms=true&withProperties=true']), (response) => {
                this.currentProduct = {
                    ...response,
                    names: response.names || [],
                    properties: createObjectFromPropertiesList(response.properties, i18nInstance),
                    locale: LOCALE_RU,
                };
                this.notifyProductUpdateObservers();
                callback(response);
            }, errorCallback);
        } catch(err) {
            console.log(err);
        }
    },
    getProduct() {
        return this.currentProduct;
    },
    getSortedProperties() {
        return Object.values(this.currentProduct.properties).sort((a, b) => {
            if (this.lastCreatedPropertyId && a.id === this.lastCreatedPropertyId) {
                return -1;
            }
            return a.localizedName.toLowerCase() > b.localizedName.toLowerCase() ? 1 : -1;
        });
    },
    getDateLastUpdate() {
        return this.lastProductUpdateTime;
    },
    registerItemUpdateObserver(observer) {
        this.productUpdateObservers.push(observer);
    },
    unRegisterItemUpdateObserver(observer) {
        this.productUpdateObservers = this.productUpdateObservers.filter(productUpdateFunction => productUpdateFunction !== observer);
    },
    notifyProductUpdateObservers() {
        this.productUpdateObservers.forEach(productUpdateFunction => productUpdateFunction(this.currentProduct));
    },
    updateProductName(locale, value) {
        postFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, '/name/']),
            {
                localizedName: value,
                locale: locale,
            },
            () => {
                if (!this.currentProduct.names) {
                    this.currentProduct.names = [];
                }
                if (this.currentProduct.names.length && this.currentProduct.names.find(it => it.locale === locale)) {
                    this.currentProduct.names.forEach(it => {
                        if (it.locale === locale) {
                            it.name = value;
                        }
                    });
                } else {
                    this.currentProduct.names.push({
                        locale: locale,
                        name: value,
                    });
                }
                this.lastProductUpdateTime = Date.now();
                lastUpdateTimeService.notifyUpdateEvent();
                this.notifyProductUpdateObservers();
            }, errorCallback, true);
    },
    updateItemLocalization(locale, value) {
        this.updateProductName(locale, value);
    },
    updateBeforeCookingRinseNeed(checked) {
        try {
            this.currentProduct.beforeCookingRinseNeed = checked;
            patchFetchRequest(
                makeUrl([PRODUCT_URL, this.currentProduct.id, '/']),
                {
                    beforeCookingRinseNeed: checked,
                },
                successCallbackEmpty,
                errorCallback,
                true);
            this.lastProductUpdateTime = Date.now();
            lastUpdateTimeService.notifyUpdateEvent();
        } catch (err) {
            console.log(err);
        }
    },
    updateComposition(fields) {
        try {
            Object.assign(this.currentProduct, fields);
            patchFetchRequest(
                makeUrl([PRODUCT_URL, this.currentProduct.id, '/']),
                fields,
                successCallbackEmpty,
                errorCallback,
                true,
            );
            this.lastProductUpdateTime = Date.now();
            lastUpdateTimeService.notifyUpdateEvent();
            this.notifyProductUpdateObservers();
        } catch (err) {
            console.log(err);
        }
    },
    addProductForm(formId) {
        try {
            this.currentProduct.productForms.push(formsStorage.getById(formId));
            postFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, FORM_URL_PART, formId, '/']), 
                null, successCallbackEmpty, errorCallback, true);
            this.lastProductUpdateTime = Date.now();
            lastUpdateTimeService.notifyUpdateEvent();
            //this.notifyProductUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    },
    deleteProductForm(formId) {
        try {
            console.log(formId);
            this.currentProduct.productForms = this.currentProduct.productForms.filter(it => it.id !== formId);
            deleteFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, FORM_URL_PART, formId, '/']), 
                null, () => null, errorCallback, true);
            this.lastProductUpdateTime = Date.now();
            lastUpdateTimeService.notifyUpdateEvent();
            //this.notifyProductUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    },
    addProductProperty(propertyCode, propertyId, i18nInstance = i18n) {
        try {
            postFetchRequest(
                makeUrl([PRODUCT_URL, this.currentProduct.id, PROPERTY_URL_PART]),
                {
                    propertyId: propertyId,
                    propertyName: propertyCode,
                },
                (response) => {
                    this.currentProduct.properties[response.id] = {...response,
                        dateCreated: new Date(Date.now()).toISOString(),
                        localizedName: propertyNamesService.getLocalization(i18nInstance.resolvedLanguage, response, true, i18nInstance),
                    };
                    this.lastCreatedPropertyId = response.id;
                    if (this.lastUsedForm && this.lastUsedForm.id) {
                        this.currentProduct.properties[response.id].productForms.push({...this.lastUsedForm});
                        this.currentProduct.properties[response.id].formIsPreFilled = true;
                    }
                    if (this.lastUsedReferenceBookId) {
                        this.currentProduct.properties[response.id].referenceBookId = this.lastUsedReferenceBookId;
                        this.currentProduct.properties[response.id].referenceBookCode = this.lastUsedReferenceBookCode;
                    }
                    this.lastProductUpdateTime = Date.now();
                    lastUpdateTimeService.notifyUpdateEvent();
                    this.notifyProductUpdateObservers();
                    },
                errorCallback);
        } catch(err) {
            console.log(err);
        }
    },
    deleteProductProperty(propertyId) {
        try {
            deleteFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, PROPERTY_URL_PART, propertyId, '/']), () => {
                delete this.currentProduct.properties[propertyId];
                this.lastCreatedPropertyId = null;
                this.lastProductUpdateTime = Date.now();
                lastUpdateTimeService.notifyUpdateEvent();
                this.notifyProductUpdateObservers();
            }, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    },
    updateProductProperty(propertyId, fieldName, fieldValue) {
        try {
            this.currentProduct.properties[propertyId][fieldName] = fieldValue;
            updateValueService.updateItemValue(() => {
                postFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, PROPERTY_URL_PART, propertyId, '/']), 
                    prepareProductProperty(this.currentProduct.properties[propertyId]), () => {
                        this.lastProductUpdateTime = Date.now();
                        lastUpdateTimeService.notifyUpdateEvent();
                        //this.notifyProductUpdateObservers();
                    }, errorCallback, true);
            });
        } catch(err) {
            console.log(err);
        }
    },
    addProductPropertyForm(propertyId, formId, include) {
        try {
            this.currentProduct.properties[propertyId].productForms.push({...formsStorage.getById(formId), included: include});
            this.lastUsedForm = {...formsStorage.getById(formId), included: include};
            postFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, PROPERTY_URL_PART, propertyId, '/']),
                prepareProductProperty(this.currentProduct.properties[propertyId]), successCallbackEmpty, errorCallback, true);
            this.lastProductUpdateTime = Date.now();
            lastUpdateTimeService.notifyUpdateEvent();
            //this.notifyProductUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    },
    deleteProductPropertyForm(propertyId, formId) {
        try {
            this.currentProduct.properties[propertyId].productForms = 
                this.currentProduct.properties[propertyId].productForms.filter(it => it.id !== formId);
            deleteFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, PROPERTY_URL_PART, propertyId, FORM_URL_PART, formId, '/']),
                successCallbackEmpty, errorCallback);
            this.lastProductUpdateTime = Date.now();
            lastUpdateTimeService.notifyUpdateEvent();
            //this.notifyProductUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    },
    updateProductPropertyReferenceBook(propertyId, referenceBookId, referenceBookCode) {
        try {
            this.currentProduct.properties[propertyId].referenceBookId = referenceBookId || null;
            this.currentProduct.properties[propertyId].referenceBookCode = referenceBookCode || null;
            this.lastUsedReferenceBookId = referenceBookId || '';
            this.lastUsedReferenceBookCode = referenceBookCode || '';
            this.updateProductProperty(propertyId, 'referenceBookId', referenceBookId || '');
        } catch(err) {
            console.log(err);
        }
    },

    updateValueLocalization(locale, value, code, propertyId) {
        try {
            if (!propertyId || !checkItemLocaleCode(code)) {
                return;
            }
            postFetchRequest(makeUrl([PROPERTIES_URL, propertyId, '/value/', code, '/name/']),
                {
                    localizedName: value,
                    locale: locale,
                },
                () => {
                    propertiesService.upsertValueNameInStorage(propertyId, locale, code, value);
                }, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    },

    updatePropertyValueField(value, propertyId) {
        try {
            if(!this.currentProduct.properties[propertyId].value) {
                this.currentProduct.properties[propertyId].value = value;
                this.updateProductProperty(propertyId, 'value', value);
            }
            //this.notifyProductUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    },

    getProperty(propertyId) {
        return this.currentProduct.properties[propertyId];
    },
    getLabelValue(i18nInstance = i18n) {
        return i18nInstance.t('app.page.product.productCategory');
    },
    getProductCategory() {
        return this.currentProduct.productCategory;
    },
    updateProductCategory(value) {
        this.currentProduct['productCategory'] = value;
        postFetchRequest(makeUrl([PRODUCT_URL, this.currentProduct.id, CATEGORY_URL_PART]), {category: value}, () => {
            this.lastFormUpdateTime = Date.now();
            lastUpdateTimeService.notifyUpdateEvent();
            this.notifyProductUpdateObservers();
            formsProductService.notifyItemsChangingObservers();
        }, errorCallback, true);   
    },
    needToAddAny() {
        return false;
    },
};
